// siteUrls — the public CharityStack marketing-site origin + page URLs, resolved
// per environment.
//
// The dashboard runs at `/dashboard/*` on the same Amplify domain as the public
// marketing site (root `/*`) in staging/prod, but at a SEPARATE dev host in
// development. So a root-relative `/pricing` would 404 in local/dev — we resolve
// an ABSOLUTE origin per stage instead.
//
// The env→origin mapping mirrors the one already used for the donor Portal link
// (settings/contact-portal/ContactPortal.tsx PORTAL_BASE_URL and settings/portal/Portal.js):
// development → the dev Amplify host, staging → staging.charitystack.com, else the
// production apex. Centralized here so the "Learn more" upsell links (PE-1730) and
// any future site links share one source and can't drift.

const MARKETING_SITE_ORIGIN = (() => {
  const env = import.meta.env.VITE_APP_ENVIRONMENT;
  if (env === 'development') return 'https://dev.dy88r2gkjfu67.amplifyapp.com';
  if (env === 'staging') return 'https://staging.charitystack.com';
  return 'https://charitystack.com';
})();

/** Absolute URL of the public pricing page, resolved for the current stage. */
export function pricingPageUrl(): string {
  return `${MARKETING_SITE_ORIGIN}/pricing`;
}

/** Absolute URL of the public Grow (marketing) product page, resolved for the current stage. */
export function growPageUrl(): string {
  return `${MARKETING_SITE_ORIGIN}/products/grow`;
}
